// Async boundary for Module Federation shared deps
import('./bootstrap.tsx')
